"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FaNavItems = void 0;

var _react = _interopRequireDefault(require("react"));

var _gatsby = require("gatsby");

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _FADesktopIcon = require("./FADesktopIcon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  link: {
    color: theme.workwaveBlue,
    textDecoration: 'none',
    fontWeight: 600,
    paddingLeft: 0,
    margin: 0,
    fontFamily: '"Poppins", "Roboto", sans-serif',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.95rem'
    }
  },
  item: {
    margin: '5px 0',
    padding: '10px 5px !important',
    border: '1px solid #FFF',
    borderRadius: '20px',
    [theme.breakpoints.down('md')]: {
      padding: '10px 4px !important'
    },
    '&:hover': {
      background: '#F5F9FF',
      border: '1px solid #E5EAF4'
    }
  }
}));

const FaNavItems = _ref => {
  let {
    items,
    noHeaderWidth,
    close
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, items.map((item, index) => /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: noHeaderWidth,
    key: index,
    className: classes.item,
    onClick: close,
    style: {
      maxWidth: noHeaderWidth ? null : '95%'
    }
  }, item.internalLink ? /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
    to: "/".concat(item.slug.current),
    style: {
      textDecoration: 'none'
    },
    id: item.navId
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_FADesktopIcon.FADesktopIcon, {
    item: item
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.link
  }, item.title))) : /*#__PURE__*/_react.default.createElement("a", {
    href: item.slug.current,
    target: "_blank",
    style: {
      textDecoration: 'none'
    },
    id: item.navId
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_FADesktopIcon.FADesktopIcon, {
    item: item
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.link
  }, item.title))))));
};

exports.FaNavItems = FaNavItems;